export class CorrespondanceAttachment {
    catId: string;
    catCorrepondanceId: string;
    catAttachmentId: string;
  sharepointFileName: string;
  documentId: string;
}